import { useQuery } from '@tanstack/react-query';
import { storesApi } from '../services/api';
import { Store } from '../types';

export const useStores = () => {
  return useQuery<Store[]>({
    queryKey: ['stores'],
    queryFn: async () => {
      const response = await storesApi.getAllStores();
      // API returns array directly, but add defensive check
      if (Array.isArray(response.data)) {
        return response.data;
      }
      console.error('Unexpected response format from getAllStores:', response.data);
      return [];
    },
    staleTime: 60 * 60 * 1000, // 1 hour
    gcTime: 2 * 60 * 60 * 1000, // 2 hours
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

export const useStore = (id: string) => {
  return useQuery<{ store: Store }>({
    queryKey: ['store', id],
    queryFn: async () => {
      const response = await storesApi.getStore(id);
      return response.data;
    },
    enabled: !!id,
    staleTime: 60 * 60 * 1000,
    gcTime: 2 * 60 * 60 * 1000,
  });
};

export const useStoresByRegion = (region: string) => {
  return useQuery<{ stores: Store[] }>({
    queryKey: ['storesByRegion', region],
    queryFn: async () => {
      const response = await storesApi.getStoresByRegion(region);
      return response.data;
    },
    enabled: !!region,
    staleTime: 60 * 60 * 1000,
    gcTime: 2 * 60 * 60 * 1000,
  });
};